module.exports = __webpack_public_path__ + "img/Numeezy.0c7275f7.jpg";